export function buildSubscriptionStore() {
  const store: { [key: string]: boolean } = {};
  return {
    isSubscribed: (key: string) => store[key] || false,
    subscribe: (key: string) => (store[key] = true),
    unsubscribe: (key: string) => (store[key] = false),
  };
}
